<script setup lang="ts">
import InputZone from '../components/inputZone.vue';
import ChatZone from '../components/chatZone.vue';

// ================================
// Composables
// ================================
const { messages, sendMessage, thinking } = conversationService();
</script>
<template>
  <div class="relativeflex flex-col h-screen overflow-hidden">
    <ui-header :title="$t('assistant.assistant')" />
    <div class="h-[100%]">
      <chat-zone :messages="messages" :thinking="thinking" class="pb-[260px]" />
    </div>
    <div class="overflow-hidden absolute bottom-0 right-0 left-0">
      <input-zone @send-message="sendMessage" />
    </div>
  </div>
</template>
